
import { mapState } from "vuex";

export default {
  computed: { ...mapState("bag", ["cartError"]) },
};
